<template>
  <button class="btn btn-primary fab align-items-center d-flex justify-content-center" @click="$emit('click')">
    <i class="fas fa-plus text-white"></i>
  </button>
</template>

<script>
export default {
  name: 'awl-fab-add-button',
};
</script>

<style lang="scss">

.fab {
  border-radius: 50%;
  box-shadow: 0 0 35px -3px rgba(0,0,0,0.4);
  height: 65px;
  width: 65px;
}

</style>
